<div class="language-switcher" [ngClass]="themeClasses">
    <ion-button (click)="toggleDropdown()" fill="clear" class="dropdown-trigger" [attr.aria-expanded]="isOpen"
        [attr.aria-haspopup]="true" aria-label="Select language" role="button" [disabled]="isLoading">
        <div class="flex-block">
            <img [src]="currentLanguageInfo.flag" [alt]="currentLanguageInfo.code" class="flag-icon" />
            {{ currentLanguageInfo.name }}
            <ion-spinner *ngIf="isLoading" name="crescent" class="loading-spinner"></ion-spinner>
            <ion-icon *ngIf="!isLoading" name="chevron-down" class="chevron-icon" [class.rotated]="isOpen"
                aria-hidden="true"></ion-icon>
        </div>
    </ion-button>

    <div class="dropdown-menu" [class.open]="isOpen" role="menu" [attr.aria-hidden]="!isOpen">
        <ion-button *ngFor="let lang of supportedLanguages" (click)="selectLanguage(lang.code)" fill="clear"
            class="dropdown-item" [class.active]="currentLanguage === lang.code"
            [class.loading]="isLoading && loadingLanguage === lang.code" [disabled]="isLoading" role="menuitem"
            [attr.aria-current]="currentLanguage === lang.code ? 'true' : 'false'"
            [attr.aria-label]="'Select ' + lang.name + ' language'">
            <div class="flex-block">
                <img [src]="lang.flag" [alt]="lang.code" class="flag-icon" />
                {{ lang.name }}
                <ion-spinner *ngIf="isLoading && loadingLanguage === lang.code" name="crescent"
                    class="item-loading-spinner"></ion-spinner>
            </div>
        </ion-button>
    </div>
</div>